import * as React from 'react';
import './GroupPersonnelPage.scss';
import { match } from "react-router";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";
import ReactTable, { Column, RowInfo } from 'react-table';
import * as ReactTooltip from 'react-tooltip';
import { DefaultLayout, RestrictedLayout, UnrestrictedLayout, SubMenu } from "../../../components/layouts/index";
import * as GroupActions from '../../../actions/groups';
import * as ToggleActions from '../../../actions/pages/togglePage';
import * as ToggleHelper from "../../../helpers/toggleHelper";
import { TogglePageItem } from '../../../reducers/pages/togglePage';
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState, IFormFilter } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { Link } from "../../../components/routing/index";
import { convertToShortDateString, convertToDateTimeString, convertToApproximateDateString } from "../../../helpers/date";
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from "../../../constants/reactTableConstants";
import * as AuthenticationHelper from '../../../helpers/authentication';
import { TextAreaFormInput, FormFilterInput } from '../../../components/form';
import { SettingsSubMenu, GroupSubMenu } from '../../../helpers/subMenuHelper';

interface IGroupPersonnelPageParams {
    groupId: number;
}

interface IGroupPersonnelPageProps {

    location: Location;
    groupId: number;
    match: match<IGroupPersonnelPageParams>;
    history: History;

    // From state
    group: Dtos.Group;
    formFilter: IFormFilter;
    personnelRoleSummaries: Dtos.PersonnelRoleSummary[];

    loadingGroup: boolean;
    loadGroupSuccess: boolean;
    loadGroupFailure: boolean;

    user: Dtos.User,
    permissions?: Dtos.PersonnelTmdPermissions[];
    toggleItems: TogglePageItem[]
}

interface IGroupPersonnelPageActions {
    clearGroup: GroupActions.IGroupClearActionCreator;
    loadGroup: GroupActions.IGroupLoadByIdActionCreator;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;

    toggleExpand: ToggleActions.IToggleExpandedStateActionCreator;

    filter: GroupActions.IGroupPersonnelRolesFilterActionCreator;
}

type GroupPersonnelPageProps = IGroupPersonnelPageProps & IGroupPersonnelPageActions;

const tableHeaderClass = "btn btn-primary btn-block rounded-0 p-3 d-flex"
const tableStyleClass: React.CSSProperties = {
    textAlign: "left",
    fontWeight: "bold",
    color: "white",
    cursor: "pointer"
}


class GroupPersonnelPage extends React.PureComponent<GroupPersonnelPageProps, any> {

    constructor(props: GroupPersonnelPageProps) {
        super(props);

        this.clearGroup = this.clearGroup.bind(this);
    }

    componentDidMount() {
        const {
            loadGroup,
            navigate,
            navigateReplace,
            groupId
        } = this.props;

        loadGroup(groupId);
    }

    componentWillReceiveProps(nextProps: GroupPersonnelPageProps) {
    }

    componentDidUpdate(prevProps: GroupPersonnelPageProps, prevState) {
        const {
            navigateReplace,
            loadGroup
        } = this.props
    }

    componentWillUpdate(nextProps: GroupPersonnelPageProps) {
    }

    componentWillUnmount() {
        this.clearGroup();
    }

    clearGroup() {
        this.props.clearGroup();
    }

    showGroup(): boolean {
        const {
            loadingGroup,
            loadGroupSuccess
        } = this.props

        if (!loadingGroup && loadGroupSuccess) {
            return true;
        }

        return false;
    }

    render() {

        const {
            loadingGroup,
            permissions,
            group
        } = this.props;

        let id = group ? group.id : 0;

        return <RestrictedLayout
            permission={Dtos.Permission.GroupPersonnelRoleView}
            subMenuItems={GroupSubMenu(id, permissions)}
            loading={loadingGroup}
        >
            {this.renderContent()}
        </RestrictedLayout>;
    }

    renderContent() {
        const {
            group,
            loadingGroup,
            loadGroupSuccess,
            loadGroupFailure,
            clearGroup,
            navigate,
            permissions
        } = this.props;

        return <div>
            <div className="row">
                <div className={"col-auto mb-2"}>
                    <h2>Group Roles</h2>
                </div>
                <div className="col" style={{ textAlign: 'right' }}>
                    <FormFilterInput formFilter={this.props.formFilter} onFilter={e => this.props.filter(e)} />
                    {(AuthenticationHelper.hasPermission(permissions, Dtos.Permission.GroupPersonnelRoleCreate) && group && group.id > 0) && (
                        <Link className={"btn btn-primary"} url={"/groups/" + group.id + '/personnel/create'}>Create</Link>
                    )}
                </div>
            </div>
            {
                loadingGroup ?
                    "Loading Personnel" :
                    null
            }
            {
                !loadingGroup ?
                    <div className="mt-2">
                        {this.renderTable()}
                    </div> :
                    null
            }
        </div>
    }


    toggle(personnelRoleSummary: Dtos.PersonnelRoleSummary) {

    }

    renderTable() {
        const {
            group,
            personnelRoleSummaries,
            toggleItems,
            toggleExpand
        } = this.props;

        if (!personnelRoleSummaries || personnelRoleSummaries.length == 0) {
            return <div className="alert alert-info d-flex">
                <div className="mr-2">
                    <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                </div>
                <span>There are currently no roles to view.</span>
            </div>
        }

        return <div>
            {personnelRoleSummaries && personnelRoleSummaries.map((item, index) => {
                const key = "group-roles-page-" + item.personnelRoleSummaryType + "-" + item.display;
                const expanded = ToggleHelper.isToggleExpanded(toggleItems, key);
                return (
                    <div key={"parent-category" + index}>
                        <div className={tableHeaderClass} style={tableStyleClass} onClick={() => toggleExpand(key)}>
                            <div>
                                <FontAwesomeIcon icon={!expanded ? FontAwesomeIcons.Solid.ANGLE_DOWN : FontAwesomeIcons.Solid.ANGLE_UP} fixedWidth transform="grow-16" className="mr-3" />
                            </div>
                            <span>{item.display}</span>
                        </div>
                        {expanded && item.personnelRoleSummaryType == Dtos.PersonnelRoleSummaryType.Role && (
                            this.renderGroupRoles(item.personnelRoleSummaries)
                        )}
                    </div>
                )
            }
            )}
        </div>
    }

    renderGroupRoles(personnelRoleSummaries: Dtos.PersonnelRoleSummary[]) {
        const showPagination = false; const {
            group
        } = this.props;

        return (
            <ReactTable
                data={personnelRoleSummaries}
                pageSizeOptions={PAGE_SIZE_OPTIONS}
                defaultPageSize={showPagination ? DEFAULT_PAGE_SIZE : personnelRoleSummaries.length}
                pageSize={showPagination ? undefined : personnelRoleSummaries.length}
                showPagination={showPagination}
                className="-striped -highlight -clickable mb-3"
                noDataText="There are currently no roles for this type"
                resizable={false}
                getTdProps={(state, rowInfo: RowInfo, column, instance) => {
                    return {
                        onClick: (e, handleOriginal) => {
                            console.log(rowInfo);
                            const url: string = "/groups/" + group.id + '/personnel/' + rowInfo.original.personnelRole.id;
                            this.props.navigate(url);

                            if (handleOriginal) {
                                handleOriginal()
                            }

                        },
                        style: {
                            color: (rowInfo && rowInfo.original && rowInfo.original.personnelRole.active) ? '#212529' : '#9e9e9e'
                        }
                    }
                }}
                columns={
                    [
                        {
                            id: "id",
                            Header: ' ',
                            accessor: "id",
                            className: "d-flex align-items-center justify-content-center",
                            maxWidth: 50,
                            Cell: (props) => <FontAwesomeIcon icon={FontAwesomeIcons.Light.ROLE} fixedWidth />
                        },
                        {
                            id: "person",
                            Header: "Person",
                            accessor: "personnelRole.personnelDisplay",
                            className: "d-flex align-items-left justify-content-left",
                            headerClassName: "text-left"
                        },
                        {
                            id: "dateStarted",
                            Header: "Date Started",
                            accessor: "personnelRole.dateStarted",
                            className: "d-flex align-items-center justify-content-center",
                            maxWidth: 180,
                            Cell: (props) => <div><span data-tip={convertToApproximateDateString(props.value)}>{convertToShortDateString(props.value)}</span><ReactTooltip /></div>
                        },
                        {
                            id: "dateCeased",
                            Header: "Date Ceased",
                            accessor: "personnelRole.dateCeased",
                            className: "d-flex align-items-center justify-content-center",
                            maxWidth: 180,
                            Cell: (props) => <div><span data-tip={convertToApproximateDateString(props.value)}>{convertToShortDateString(props.value)}</span><ReactTooltip /></div>
                        }
                    ]
                }
            />
        );
    }

}


const mapStateToProps = (state: ITmdState, ownProps: GroupPersonnelPageProps): IGroupPersonnelPageProps => {

    let group: Dtos.Group | undefined = !(state.groups.formData instanceof Array) ? state.groups.formData : undefined;
    let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];

    return {

        match: ownProps.match,
        groupId: ownProps.match ? ownProps.match.params.groupId : undefined!,

        history: ownProps.history,
        location: state.routing.location,

        group: group!,
        formFilter: state.groups.formFilterPersonnelRoles,
        personnelRoleSummaries: state.groups.formFilteredPersonnelRoles,

        loadingGroup: state.groups.loadState && state.groups.loadState.status == RequestState.Pending,
        loadGroupSuccess: state.groups.loadState && state.groups.loadState.status == RequestState.Success,
        loadGroupFailure: state.groups.loadState && state.groups.loadState.status == RequestState.Failure,

        user: state.user.data,
        permissions: permissions,
        toggleItems: state.togglePage.items
    };
};

const mapDispatchToProps = (dispatch): IGroupPersonnelPageActions => {
    return {
        navigate: bindActionCreators(routerActions.push, dispatch),
        navigateReplace: bindActionCreators(routerActions.replace, dispatch),

        loadGroup: bindActionCreators(GroupActions.LoadGroupById, dispatch),
        clearGroup: bindActionCreators(GroupActions.Clear, dispatch),

        toggleExpand: bindActionCreators(ToggleActions.ToggleExpanded, dispatch),

        filter: bindActionCreators(GroupActions.PersonnelRolesFilter, dispatch)
    };
};

export default
    connect(mapStateToProps, mapDispatchToProps)(GroupPersonnelPage);
